import moment from "moment";
import { stringToMoment } from "../helpers/dateHelper";
import { UploadStatusJSON } from "./json/uploadStatusJSON";

export enum UPLOAD_STATUS {
    WORKING = "Bezig",
    STALLED = "Vastgelopen",
    DONE = "Klaar",
    ERROR = "Error",
    CANCELLED = "Gestopt",
}

export class UploadStatus {
    constructor(
        public id: number,
        public dateCreated: moment.Moment,
        public totalAmount: number,
        public successAmount: number,
        public erroredAmount: number,
        public skippedAmount: number,
        public errorReferences: string[],
        public skippedReferences: string[],
        public status: UPLOAD_STATUS,
    ) {}

    static fromJSON(json: UploadStatusJSON | null | undefined): UploadStatus | null {
        if (!json) {
            return null;
        }

        const id = json.id;
        if (id === null || id === undefined) {
            console.error("UploadStatus JSON missing required 'id'. Returning null.");

            return null;
        }

        let status = UPLOAD_STATUS.WORKING;
        if (typeof json.status === "string") {
            const upperStatus = json.status.toUpperCase();
            if (upperStatus === "STALLED") status = UPLOAD_STATUS.STALLED;
            else if (upperStatus === "DONE") status = UPLOAD_STATUS.DONE;
            else if (upperStatus === "WORKING") status = UPLOAD_STATUS.WORKING;
            else if (upperStatus === "ERROR") status = UPLOAD_STATUS.ERROR;
            else if (upperStatus === "CANCELLED") status = UPLOAD_STATUS.CANCELLED;
        }

        const parsedDate = stringToMoment(json.date_created);
        const dateCreated = parsedDate && parsedDate.isValid() ? parsedDate : moment();

        const totalAmount = json.amount_to_upload ?? 0;
        const successAmount = json.success_amount ?? 0;
        const erroredAmount = json.errored_amount ?? 0;
        const skippedAmount = json.skipped_amount ?? 0;

        const errorReferences = json.errored_references ?? [];
        const skippedReferences = json.skipped_references ?? [];

        return new UploadStatus(
            id,
            dateCreated,
            totalAmount,
            successAmount,
            erroredAmount,
            skippedAmount,
            errorReferences,
            skippedReferences,
            status,
        );
    }

    get isCompleted() {
        return (
            this.status === UPLOAD_STATUS.DONE ||
            this.status === UPLOAD_STATUS.STALLED ||
            this.status === UPLOAD_STATUS.CANCELLED
        );
    }
}
